import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { UserInfo } from '@/types/user';

interface UserState {
  userInfo: UserInfo | null;
  setUserInfo: (info: UserInfo) => void;
  clearUserInfo: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      userInfo: null,
      setUserInfo: (info) => {
        console.log('Setting userInfo:', info);
        set({ userInfo: info });
      },
      clearUserInfo: () => {
        console.log('Clearing userInfo');
        set({ userInfo: null });
      },
    }),
    {
      name: 'user-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ userInfo: state.userInfo }),
      version: 1,
      // 恢复状态
      onRehydrateStorage: () => (state) => {
        // console.log('Hydrated state:', state);
      },
    }
  )
);

// 导出一些常用的选择器
export const selectUserInfo = (state: UserState) => state.userInfo;
export const selectUid = (state: UserState) => state.userInfo?.id;
export const selectNickName = (state: UserState) => state.userInfo?.name;